import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

import {
  FETCH_TAGS,
  MEDIA,
  GENERATE_IMAGE_PRESIGNED_URL,
  VIDEO_COMPILATION
} from '../../constants/endpoints';
import api from '../../utils/api';
import { useVpSnackbar } from '../../vp-ui';
import {
  CAMPAIGN_SUBMISSION_DETAILS,
  CAMPAIGN_SUBMISSIONS_LIST,
  GENERATE_CLP_MEDIA_PRESIGNED_URL
} from './queries';

const fetchMediaInsights = ({ queryKey }) => {
  const mediaIds = queryKey[1]?.join(',');

  return api.get(`/v1/media/insights?mediaIds=${mediaIds}`);
};

export const useFetchMediaInsights = (mediaIds) => {
  const { addSnackbarError } = useVpSnackbar();
  return useQuery(['/v1/media/insights', mediaIds], fetchMediaInsights, {
    enabled: !!mediaIds?.length,
    onError: (error) => {
      addSnackbarError({ error, title: 'Error retrieving media insights' });
    }
  });
};

const updateMediaDetails = ({ mediaId, data }) => api.put(`${MEDIA}/${mediaId}`, data);
export const useUpdateMediaDetails = () => {
  const queryClient = useQueryClient();

  return useMutation(updateMediaDetails, {
    onSuccess: () => {
      queryClient.invalidateQueries(CAMPAIGN_SUBMISSION_DETAILS);
      queryClient.invalidateQueries(CAMPAIGN_SUBMISSIONS_LIST);
      queryClient.invalidateQueries(VIDEO_COMPILATION);
    }
  });
};

const updateMediaTags = ({ mediaId, data }) => api.put(`${MEDIA}/${mediaId}/tags`, data);
export const useUpdateMediaTags = () => {
  const queryClient = useQueryClient();

  return useMutation(updateMediaTags, {
    onSuccess: (data, variables) => {
      if (variables?.data?.newTags?.length) {
        // if we are creating a new tag -> refetch tags list
        queryClient.invalidateQueries(FETCH_TAGS);
      }
      // could do optimistic update to add new tag list item -> will need to look into it more
      queryClient.invalidateQueries([CAMPAIGN_SUBMISSION_DETAILS]);
      queryClient.invalidateQueries([MEDIA]);
    }
  });
};

export const createThumbnailPresignedUrl = () => api.get(GENERATE_IMAGE_PRESIGNED_URL);

export const useCreateThumbnailPresignedUrl = () => useMutation(createThumbnailPresignedUrl);

const uploadToPresignedUrl = ({ presignedUrl, file }) => {
  // using raw axios here because the "default" middlewares should not be applied to this request
  return axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'public-read'
    }
  });
};
export const useUploadToPresignedUrl = () => useMutation(uploadToPresignedUrl);

const fetchMediaById = ({ queryKey }) => api.get(`${MEDIA}/${queryKey[1]}`);

export const useFetchMediaById = (mediaId) => {
  const { addSnackbarError } = useVpSnackbar();
  return useQuery([MEDIA, mediaId], fetchMediaById, {
    onError: (error) => {
      addSnackbarError({ error, title: 'Error retrieving media details' });
    }
  });
};

const fetchClpUploadPresignedUrl = (payload) => api.post(GENERATE_CLP_MEDIA_PRESIGNED_URL, payload);
export const useFetchClpUploadPresignedUrl = (payload) => {
  return useMutation([GENERATE_CLP_MEDIA_PRESIGNED_URL, payload], fetchClpUploadPresignedUrl);
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useMediaData.js